import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { BadgeCheck, Save } from 'lucide-react';
import { market } from '../lib/api';
import ImageUploader from './ImageUploader';

const FIELDS = [['description', 'About the brand', true], ['history', 'Brand history', true], ['website', 'Official website'], ['contact_email', 'Contact email'], ['contact_phone', 'Contact phone'], ['warranty_info', 'Warranty information', true], ['return_info', 'Return information', true]];

function OneBrand({ b }) {
  const [f, setF] = useState(b);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const body = Object.fromEntries(['logo_url', 'banner_url', ...FIELDS.map(x => x[0])].map(k => [k, f[k] ?? '']));
      setF(await market.updateBrand(b.id, body)); toast.success('Brand store updated');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-2 border-t border-border pt-3" data-testid={`brand-editor-${b.slug}`}>
      <div className="flex items-center gap-2 font-semibold">{b.name}<BadgeCheck className="w-4 h-4 text-[#1B5E20]"/>
        <Link to={`/brands/${b.slug}`} className="text-xs underline text-[#D35400]">View store</Link></div>
      <div className="flex flex-wrap gap-3">
        <ImageUploader value={f.logo_url || ''} onChange={u => setF({ ...f, logo_url: u })} label="Logo" testId={`brand-logo-${b.slug}`}/>
        <ImageUploader value={f.banner_url || ''} onChange={u => setF({ ...f, banner_url: u })} label="Banner" testId={`brand-banner-${b.slug}`}/>
      </div>
      <div className="grid md:grid-cols-2 gap-2">
        {FIELDS.map(([k, l, area]) => area
          ? <textarea key={k} data-testid={`brand-${k}`} value={f[k] || ''} onChange={e => setF({ ...f, [k]: e.target.value })} placeholder={l} rows={2} className="rounded-lg border border-border px-3 py-2 text-sm"/>
          : <input key={k} data-testid={`brand-${k}`} value={f[k] || ''} onChange={e => setF({ ...f, [k]: e.target.value })} placeholder={l} className="rounded-lg border border-border px-3 py-2 text-sm"/>)}
      </div>
      <button data-testid={`brand-save-${b.slug}`} disabled={busy} onClick={save} className="btn-primary text-sm"><Save className="w-4 h-4"/>Save brand store</button>
    </div>
  );
}

export default function BrandEditor() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { market.myBrands().then(d => setBrands(d.items)).catch(() => {}); }, []);
  if (!brands.length) return null;
  return (
    <section className="card-soft p-4" data-testid="brand-editor">
      <div className="font-heading font-bold">Your brand stores</div>
      {brands.map(b => <OneBrand key={b.id} b={b}/>)}
    </section>
  );
}
